import React from 'react';
import { createRoot } from 'react-dom/client';

const Icons = () => (
  <svg>
    <symbol id="icon-facebook" viewBox="0 0 25 24">
      <title>facebook</title>
      <g id="icon-facebook">
        <path
          id="Vector"
          d="M15.8129 13.3118L16.3559 9.513H12.9538V7.04381C12.9538 6.00509 13.4303 4.99011 14.9541 4.99011H16.5V1.75523C16.5 1.75523 15.0926 1.5 13.7517 1.5C10.948 1.5 9.11398 3.32222 9.11398 6.61645V9.513H6V13.3118H9.11398V22.5H12.9483V13.3118H15.8074H15.8129Z"
          fill="currentColor"
        />
      </g>
    </symbol>
    <symbol id="icon-instagram" viewBox="0 0 25 24">
      <title>instagram</title>
      <g id="icon-instagram">
        <path
          d="M18.063 5.25C17.3806 5.25 16.8347 5.80185 16.8347 6.47831C16.8347 7.15478 17.3866 7.70663 18.063 7.70663C18.7395 7.70663 19.2913 7.15478 19.2913 6.47831C19.2913 5.80185 18.7395 5.25 18.063 5.25Z"
          fill="currentColor"
        />
        <path
          d="M12.592 6.82812C9.74373 6.82812 7.42358 9.14827 7.42358 11.9965C7.42358 14.8448 9.74373 17.1649 12.592 17.1649C15.4403 17.1649 17.7604 14.8448 17.7604 11.9965C17.7604 9.14827 15.4403 6.82812 12.592 6.82812ZM12.592 15.3076C10.7644 15.3076 9.28089 13.8242 9.28089 11.9965C9.28089 10.1689 10.7644 8.68543 12.592 8.68543C14.4196 8.68543 15.9031 10.1689 15.9031 11.9965C15.9031 13.8242 14.4196 15.3076 12.592 15.3076Z"
          fill="currentColor"
        />
        <path
          d="M16.6923 22.4941H8.30771C4.83046 22.4941 2 19.6636 2 16.1864V7.80178C2.00593 4.33046 4.83639 1.5 8.31365 1.5H16.6982C20.1755 1.5 23.0059 4.33046 23.0059 7.80771V16.1923C23.0059 19.6695 20.1755 22.5 16.6982 22.5L16.6923 22.4941ZM8.31365 3.47598C5.92823 3.47598 3.98192 5.41636 3.98192 7.80771V16.1923C3.98192 18.5777 5.92229 20.524 8.31365 20.524H16.6982C19.0836 20.524 21.03 18.5836 21.03 16.1923V7.80771C21.03 5.42229 19.0896 3.47598 16.6982 3.47598H8.31365Z"
          fill="currentColor"
        />
      </g>
    </symbol>
    <symbol id="icon-twitter" viewBox="0 0 25 24">
      <title>twitter</title>
      <g id="icon-twitter">
        <path
          d="M22.9072 4.01991C22.2428 4.38782 21.5051 4.60738 20.7821 4.75573C21.1241 4.68452 21.6273 3.93684 21.8276 3.62827C22.1353 3.16542 22.3894 2.6373 22.531 2.06763C22.5506 2.02609 22.5652 1.96675 22.531 1.93115C22.4871 1.90741 22.4529 1.91928 22.4187 1.94302C21.6175 2.46521 20.787 2.84499 19.9028 3.11201C19.8295 3.13575 19.7758 3.11201 19.7269 3.05861C19.6537 2.95773 19.5853 2.86279 19.5071 2.78565C19.1358 2.39994 18.7353 2.10324 18.2858 1.87774C17.6947 1.58698 17.0499 1.46237 16.4148 1.50984C15.7944 1.55731 15.1886 1.77093 14.6415 2.12104C14.0895 2.47114 13.601 2.95773 13.2102 3.53926C12.8047 4.14453 12.5067 4.86254 12.3553 5.62209C12.2087 6.35197 12.2185 7.07592 12.3113 7.81767C12.326 7.94228 12.3113 7.95415 12.2234 7.94228C8.75979 7.31921 5.8971 5.81791 3.56688 2.59576C3.46429 2.45334 3.41056 2.45334 3.32751 2.60763C2.3114 4.45903 2.8048 7.43789 4.07494 8.90359C4.24592 9.09941 4.4169 9.29523 4.60742 9.47325C4.53902 9.49105 3.69389 9.37831 2.9367 8.90359C2.83411 8.82645 2.78526 8.86798 2.77549 9.0104C2.76572 9.21216 2.77549 9.39611 2.8048 9.60973C3.0002 11.4908 4.07005 13.2295 5.54048 13.9059C5.71635 13.995 5.90687 14.0721 6.09739 14.1136C5.7652 14.2026 5.41835 14.2679 4.46086 14.173C4.34362 14.1433 4.29477 14.2204 4.34362 14.3569C5.06174 16.7424 6.6201 17.4545 7.78276 17.858C7.93909 17.8936 8.09541 17.8936 8.25174 17.9351C8.24197 17.9529 8.2322 17.9529 8.22243 17.9707C7.8365 18.6887 6.49797 19.2169 5.87267 19.4839C4.73932 19.9645 3.50337 20.1841 2.30651 20.0417C2.11599 20.0061 2.07202 20.012 2.02317 20.0417C1.96944 20.0832 2.01829 20.1366 2.07691 20.196C2.32117 20.3918 2.56542 20.5639 2.81945 20.73C3.58154 21.2226 4.37293 21.6083 5.2034 21.8872C9.49257 23.3232 14.3191 22.2669 17.5384 18.3861C20.064 15.336 20.9531 11.1288 20.9531 6.9157C20.9531 6.74955 21.1143 6.66054 21.2072 6.57153C21.8666 5.9722 22.3942 5.25418 22.8876 4.4531C23 4.27508 23 4.11486 23 4.04959V4.02585C23 3.96058 23 3.97838 22.9121 4.02585L22.9072 4.01991Z"
          fill="currentColor"
        />
      </g>
    </symbol>
    <symbol id="icon-caret-down" viewBox="0 0 15 8">
      <title>caret-up</title>
      <polygon points="0 2.10909091 7.37931034 8 7.65517241 8 15 2.10909091 13.8275862 0 7.48275862 4.90909091 1.13793103 0 0 2.10909091" />
    </symbol>
    <symbol id="icon-caret-up" viewBox="0 0 15 8">
      <title>caret-up</title>
      <polygon points="0 5.89090909 7.37931034 0 7.65517241 0 15 5.89090909 13.8275862 8 7.48275862 3.09090909 1.13793103 8" />
    </symbol>
    <symbol id="icon-close" viewBox="0 0 23 23">
      <title>close</title>
      <path d="M9.89949494,11.3137085 L9.1038288e-14,21.2132034 L1.41421356,22.627417 L11.3137085,12.7279221 L21.2132034,22.627417 L22.627417,21.2132034 L12.7279221,11.3137085 L22.627417,1.41421356 L21.2132034,3.55271368e-15 L11.3137085,9.89949494 L1.41421356,-3.10862447e-15 L9.25926003e-14,1.41421356 L9.89949494,11.3137085 Z" />
    </symbol>
    <symbol id="icon-close-small" viewBox="0 0 21 21">
      <title>close-small</title>
      <g clipPath="url(#clip0_1829_27714)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.3 0L20.4 18.1L18.1 20.4L0 2.3L2.3 0Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.1 0L20.4 2.3L2.3 20.4L0 18.1L18.1 0Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_1829_27714">
          <rect width="20.4" height="20.4" fill="white" />
        </clipPath>
      </defs>
    </symbol>

    <symbol id="icon-key" viewBox="0 0 14 16">
      <title>key</title>
      <path d="M9.03266667,-2.66453526e-15 L7.18133333,1.85133333 L7.18133333,4.80266667 L7.44533333,5.06866667 L3.51466667,9 L0,12.5146667 L1.33266667,13.848 L2.666,15.1813333 L6.18066667,11.6666667 L4.848,10.3333333 L8.77466667,6.406 L9.03266667,6.66666667 L11.996,6.66666667 L13.848,4.81466667 L13.848,1.85133333 L11.996,-2.66453526e-15 L9.03266667,-2.66453526e-15 Z M9.18066667,3.92133333 L9.18066667,2.74066667 L9.922,2 L11.1066667,2 L11.848,2.74066667 L11.848,3.926 L11.1066667,4.66666667 L9.922,4.66666667 L9.18066667,3.92133333 Z" />
    </symbol>
    <symbol id="icon-menu" viewBox="0 0 22 14">
      <title>menu</title>
      <path
        d="M21,12c0.5,0,0.9,0.4,1,0.9l0,0.1c0,0.6-0.4,1-1,1H1c-0.6,0-1-0.4-1-1c0-0.6,0.4-1,1-1H21z M21,6c0.5,0,0.9,0.4,1,0.9L22,7
		c0,0.6-0.4,1-1,1H1C0.4,8,0,7.6,0,7c0-0.6,0.4-1,1-1H21z M21,0c0.5,0,0.9,0.4,1,0.9L22,1c0,0.6-0.4,1-1,1H1C0.4,2,0,1.6,0,1
		c0-0.6,0.4-1,1-1H21z"
      />
    </symbol>
    <symbol id="icon-menu-close" viewBox="0 0 16 16">
      <title>menu close</title>
      <path d="M7.77817459,6.36396103 L1.41421356,7.54951657e-15 L-5.04041253e-14,1.41421356 L6.36396103,7.77817459 L-5.10702591e-14,14.1421356 L1.41421356,15.5563492 L7.77817459,9.19238816 L14.1421356,15.5563492 L15.5563492,14.1421356 L9.19238816,7.77817459 L15.5563492,1.41421356 L14.1421356,1.0658141e-14 L7.77817459,6.36396103 Z" />
    </symbol>
    <symbol id="icon-search" viewBox="0 0 19 21">
      <title>search</title>
      <path d="M3.9961168,1.42108547e-14 L-5.68434189e-14,4.01005582 L-5.68434189e-14,10.5268397 L3.9961168,14.5361864 L10.4883935,14.5361864 L11.9311217,13.0881698 L19,20.11997 L19,17.4236564 L13.3696107,11.645117 L14.4845103,10.5268397 L14.4845103,4.01005582 L10.4883935,1.42108547e-14 L3.9961168,1.42108547e-14 Z M1.76702407,9.79219467 L1.76702407,4.74470089 L4.72737226,1.77208302 L9.82425815,1.77208302 L12.7174863,4.74470089 L12.7174863,9.79219467 L9.75713809,12.7641034 L4.72737226,12.7641034 L1.76702407,9.79219467 Z" />
    </symbol>
    <symbol id="icon-external" viewBox="0 0 15 15">
      <title>arrow diagonal</title>
      <g transform="translate(1, 1)">
        <path
          d="M0.7,0v2.1h7.8L0,10.6L1.4,12l8.5-8.5v7.8H12V0H0.7z"
          fill="currentColor"
        />
      </g>
    </symbol>
    <symbol id="icon-check" viewBox="0 0 16 16">
      <title>Check</title>
      <path d="M6.01040764,10.8890873 L13.8994949,3 L16.0208153,5.12132034 L6.12132034,15.0208153 L5.76776695,14.6672619 L5.65685425,14.7781746 L-2.5268676e-13,9.12132034 L2.12132034,7 L6.01040764,10.8890873 Z" />
    </symbol>
    <symbol id="icon-subscription" viewBox="0 0 40 40">
      <title>Subscription</title>
      <path d="M9,12V28H31V12Zm17.49,2L20,20.49,13.51,14ZM11,26V14.51l9,9,9-9V26Z" />
    </symbol>
    <symbol id="icon-download" viewBox="0 0 10 18">
      <title>Download</title>
      <polygon points="10 13 6 13 6 0 4 0 4 13 0 13 4 17 4 18 6 18 6 17" />
    </symbol>
    <symbol id="icon-rss" viewBox="0 0 50 51">
      <title>RSS</title>
      <path d="M0.428,27.085 C6.618,27.085 12.437,29.503 16.81,33.901 C21.191,38.299 23.603,44.157 23.603,50.393 L33.142,50.393 C33.142,32.28 18.466,17.545 0.428,17.545 L0.428,27.085 Z M0.443,10.174 C22.504,10.174 40.453,28.221 40.453,50.405 L49.992,50.405 C49.992,22.96 27.763,0.635 0.443,0.635 L0.443,10.174 Z M13.634,43.741 C13.634,47.389 10.675,50.348 7.027,50.348 C3.379,50.348 0.42,47.39 0.42,43.741 C0.42,40.091 3.378,37.134 7.026,37.134 C10.674,37.134 13.634,40.091 13.634,43.741 Z" />
    </symbol>
    <symbol id="icon-search-outline" viewBox="0 0 21.8 21.8">
      <title>search outline</title>
      <path
        d="M2.3,2.3c3-3,7.9-3.1,11-0.2l0.2,0.2l0.2,0.2c2.3,2.4,2.7,6,1.3,8.8l6,6c0.9,0.9,1,2.3,0.2,3.3l-0.1,0.1l-0.4,0.4
                c-0.9,0.9-2.3,0.9-3.3,0l-0.1-0.1l-6-6c-2.9,1.4-6.6,0.9-9-1.5C-0.8,10.4-0.8,5.4,2.3,2.3z M14.2,12.7c-0.2,0.3-0.4,0.5-0.7,0.8
                c-0.2,0.2-0.5,0.5-0.8,0.7l5.7,5.7c0.3,0.3,0.8,0.4,1.1,0.1l0.1-0.1l0.4-0.4c0.3-0.3,0.3-0.7,0-1l-0.1-0.1L14.2,12.7z M12.2,3.3
                C9.7,1,5.9,1,3.4,3.4C1,5.9,1,9.9,3.4,12.4c2,2,5.1,2.4,7.5,1.1l0,0c0.1-0.1,0.2-0.2,0.3-0.2c0.4-0.2,0.8-0.6,1.1-0.9
                c0.4-0.4,0.7-0.7,0.9-1.1c0-0.1,0.1-0.2,0.2-0.3c1.3-2.3,1-5.3-0.9-7.3l-0.2-0.2L12.2,3.3z"
      />
    </symbol>
    <symbol id="icon-arrow-up" viewBox="0 0 12 12.9">
      <title>arrow up</title>
      <polygon points="6.9,12.9 6.9,3.5 10.7,7.3 12,6 6,0 0,6 1.3,7.3 5.1,3.5 5.1,12.9" />
    </symbol>
    <symbol id="icon-zoom-in" viewBox="0 0 30 30">
      <title>zoom-in</title>
      <path d="M11.6667 30V26.6667H5.68333L13.1833 19.1667L10.8333 16.8167L3.33333 24.3167V18.3333H0V30H11.6667ZM19.1667 13.1833L26.6667 5.68333V11.6667H30V0H18.3333V3.33333H24.3167L16.8167 10.8333L19.1667 13.1833Z" />
    </symbol>
    <symbol id="icon-zoom-out" viewBox="0 0 30 30">
      <title>zoom-out</title>
      <path
        d="M1.51693 16.8167L1.51693 20.15L7.50026 20.15L0.000261512 27.65L2.35026 30L9.85026 22.5L9.85026 28.4833L13.1836 28.4833L13.1836 16.8167L1.51693 16.8167Z"
        fill="white"
      />
      <path
        d="M20.3336 7.49977L27.8336 -0.00022718L30.1836 2.34977L22.6836 9.84977L28.6669 9.84977L28.6669 13.1831L17.0003 13.1831L17.0003 1.51644L20.3336 1.51644L20.3336 7.49977Z"
        fill="white"
      />
    </symbol>
    <symbol id="icon-quote" viewBox="0 0 69 58">
      <title>quote</title>
      <path
        d="M32,20.75V16.08A16,16,0,1,0,15.92,32h1.49a1.66,1.66,0,0,1,1.5,2.36l-7.1,15.37a5.8,5.8,0,1,0,10.64,4.59L28.62,38.6A48.87,48.87,0,0,0,32,20.75Z"
        fill="#fff"
        fillOpacity="0.8"
      />
      <path
        d="M69,20.75V16.08A16,16,0,1,0,52.92,32h1.49a1.66,1.66,0,0,1,1.5,2.36l-7.1,15.37a5.8,5.8,0,1,0,10.64,4.59L65.62,38.6A48.87,48.87,0,0,0,69,20.75Z"
        fill="#fff"
        fillOpacity="0.8"
      />
    </symbol>
    <symbol id="icon-chevron-right" viewBox="0 0 40 46">
      <title>chevron-right</title>
      <path
        d="M37.5 18.6506C40.8333 20.5751 40.8333 25.3864 37.5 27.3109L7.5 44.6314C4.16666 46.5559 -2.061e-06 44.1503 -1.89276e-06 40.3013L-3.78552e-07 5.66025C-2.10306e-07 1.81125 4.16667 -0.594376 7.5 1.33013L37.5 18.6506Z"
        fill="#fff"
      />
    </symbol>
    <symbol id="icon-pdf" viewBox="0 0 24 24">
      <title>pdf</title>
      <path
        d="M21.6 0H7.2C5.88 0 4.8 1.08 4.8 2.4V16.8C4.8 18.12 5.88 19.2 7.2 19.2H21.6C22.92 19.2 24 18.12 24 16.8V2.4C24 1.08 22.92 0 21.6 0ZM21.6 16.8H7.2V2.4H21.6V16.8ZM2.4 4.8H0V21.6C0 22.92 1.08 24 2.4 24H19.2V21.6H2.4V4.8ZM16.8 12V8.4C16.8 7.74 16.26 7.2 15.6 7.2H13.2V13.2H15.6C16.26 13.2 16.8 12.66 16.8 12ZM14.4 8.4H15.6V12H14.4V8.4ZM19.2 10.8H20.4V9.6H19.2V8.4H20.4V7.2H18V13.2H19.2V10.8ZM9.6 10.8H10.8C11.46 10.8 12 10.26 12 9.6V8.4C12 7.74 11.46 7.2 10.8 7.2H8.4V13.2H9.6V10.8ZM9.6 8.4H10.8V9.6H9.6V8.4Z"
        fill="#001E64"
      />
    </symbol>
    <symbol id="icon-excel" viewBox="0 0 24 24">
      <title>excel</title>
      <path
        d="M16.3658 0L22.3978 5.31536L22.3981 9.16876H24V20.4779H22.3981V21.8836C22.3981 22.4448 22.1452 22.983 21.6956 23.3801C21.2457 23.7769 20.6359 24 19.9997 24H4.00003C3.3638 24 2.75391 23.7769 2.30404 23.3801C1.85444 22.983 1.60161 22.4448 1.60161 21.8836V20.4698H0V9.16066H1.60192L1.60162 2.11677C1.60162 1.55554 1.85446 1.01701 2.30405 0.620261C2.75395 0.223206 3.36384 0.000339148 4.00004 0.000339148L16.3658 0ZM20.0272 20.4697H4.00012V21.8754H19.9997L20.0272 20.4697ZM9.64742 12.2543H5.82141V17.3032H9.6566V16.2852H7.2585V15.2271H9.33634V14.2818H7.2585V13.2721H9.64742V12.2543ZM11.478 12.2543H9.94963L11.4507 14.7261L9.79398 17.3029H11.3407L12.4483 15.461L13.5559 17.3029H15.0938L13.4462 14.7261L14.9473 12.2543H13.4278L12.4484 13.9991L11.478 12.2543ZM16.7593 12.2543H15.3134V17.3032H18.9748L18.9745 16.2852H16.7504V12.2462L16.7593 12.2543ZM14.288 2.11601H3.99997V9.16821H19.9996V7.72225H14.279V2.11587L14.288 2.11601ZM16.6861 3.26306V5.60562H19.3224L16.6861 3.26306Z"
        fill="#001E64"
      />
    </symbol>
    <symbol id="icon-graphics" viewBox="0 0 24 18">
      <title>graphics</title>
      <path
        d="M18.5625 13.5H19.6406C19.9219 13.5 20.25 13.2188 20.25 12.9375V2.10938C20.25 1.82812 19.9219 1.5 19.6406 1.5H18.5625C18.2812 1.5 18 1.82812 18 2.10938V12.9375C18 13.2188 18.2812 13.5 18.5625 13.5ZM9.5625 13.5H10.6406C10.9219 13.5 11.25 13.2188 11.25 12.9375V3.60938C11.25 3.32812 10.9219 3 10.6406 3H9.5625C9.28125 3 9 3.32812 9 3.60938V12.9375C9 13.2188 9.28125 13.5 9.5625 13.5ZM14.0625 13.5H15.1406C15.4219 13.5 15.75 13.2188 15.75 12.9375V6.60938C15.75 6.32812 15.4219 6 15.1406 6H14.0625C13.7812 6 13.5 6.32812 13.5 6.60938V12.9375C13.5 13.2188 13.7812 13.5 14.0625 13.5ZM23.25 15.75H2.25V0.75C2.25 0.375 1.875 0 1.5 0H0.75C0.328125 0 0 0.375 0 0.75V16.5C0 17.3438 0.65625 18 1.5 18H23.25C23.625 18 24 17.6719 24 17.25V16.5C24 16.125 23.625 15.75 23.25 15.75ZM5.0625 13.5H6.14062C6.42188 13.5 6.75 13.2188 6.75 12.9375V9.60938C6.75 9.32812 6.42188 9 6.14062 9H5.0625C4.78125 9 4.5 9.32812 4.5 9.60938V12.9375C4.5 13.2188 4.78125 13.5 5.0625 13.5Z"
        fill="#001E64"
      />
    </symbol>
    <symbol id="icon-lock" viewBox="0 0 16 21">
      <title>lock</title>
      <path
        d="M14 7H13V5C13 2.24 10.76 0 8 0C5.24 0 3 2.24 3 5V7H2C0.9 7 0 7.9 0 9V19C0 20.1 0.9 21 2 21H14C15.1 21 16 20.1 16 19V9C16 7.9 15.1 7 14 7ZM5 5C5 3.34 6.34 2 8 2C9.66 2 11 3.34 11 5V7H5V5ZM14 19H2V9H14V19ZM8 16C9.1 16 10 15.1 10 14C10 12.9 9.1 12 8 12C6.9 12 6 12.9 6 14C6 15.1 6.9 16 8 16Z"
        fill="currentColor"
      />
    </symbol>
    <symbol id="icon-lock-outlined" viewBox="0 0 28 36">
      <title>lock-outlined</title>
      <path
        d="M22 18H24.8C25.4628 18 26 18.5372 26 19.2V32.8C26 33.4628 25.4628 34 24.8 34H3.2C2.53726 34 2 33.4628 2 32.8V19.2C2 18.5372 2.53726 18 3.2 18H6M22 18V10C22 7.33334 20.4 2 14 2C7.6 2 6 7.33334 6 10V18M22 18H6"
        stroke="#001E64"
        fill="none"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </symbol>

    <symbol id="icon-arrow-right" viewBox="0 0 16 16">
      <title>arrow-right</title>
      <g>
        <path
          d="M8 0L6.5 1.5L12 7H0V9H12L6.5 14.5L8 16L16 8L8 0Z"
          fill="currentColor"
        />
      </g>
    </symbol>
    <symbol id="icon-link-arrow" viewBox="0 0 20 14">
      <title>link-arrow</title>
      <path
        d="M1,7H19m0,0L13.33,1M19,7l-5.67,6"
        fill="none"
        stroke="#212960"
        strokeLinecap="round"
        strokeWidth="2"
      />
    </symbol>
    <symbol id="icon-arrow-left" viewBox="0 0 16 16">
      <title>arrow-left</title>
      <path d="M8 0L9.5 1.5L4 7H16V9H4L9.5 14.5L8 16L0 8L8 0Z" fill="#001E64" />
    </symbol>
    <symbol id="icon-arrow-right-white" viewBox="0 0 20 14">
      <title>arrow-right-white</title>
      <path
        d="M1,7H19m0,0L13.33,1M19,7l-5.67,6"
        fill="none"
        stroke="#ffffff"
        strokeLinecap="round"
        strokeWidth="2"
      />
    </symbol>

    <symbol id="icon-arrow-left-white" viewBox="0 0 20 14">
      <title>arrow-left-white</title>
      <path
        d="M20,7.5H2m0,0,5.67,6M2,7.5l5.67-6"
        transform="translate(-1 -0.5)"
        fill="none"
        stroke="#ffffff"
        strokeLinecap="round"
        strokeWidth="2"
      />
    </symbol>
    <symbol id="icon-download-outline" viewBox="0 0 22 22">
      <title>download-outline</title>
      <path
        d="M18.9997 14.9987V18.9987H2.99967V14.9987H0.333008V18.9987C0.333008 20.4654 1.53301 21.6654 2.99967 21.6654H18.9997C20.4663 21.6654 21.6663 20.4654 21.6663 18.9987V14.9987H18.9997ZM17.6663 9.66537L15.7863 7.78537L12.333 11.2254V0.332031H9.66634V11.2254L6.21301 7.78537L4.33301 9.66537L10.9997 16.332L17.6663 9.66537Z"
        fill="currentColor"
      />
    </symbol>
    <symbol id="icon-caret-down-rounded" viewBox="0 0 14 8">
      <title>caret-down-rounded</title>
      <path
        fill="none"
        d="M13 1L7 7L1 1"
        stroke="#001E64"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </symbol>
    <symbol id="icon-caret-up-rounded" viewBox="0 0 14 8">
      <title>caret-up-rounded</title>
      <path
        fill="none"
        d="M1,7l6-6l6,6"
        stroke="#001E64"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </symbol>
    <symbol id="icon-arrow-down" viewBox="0 0 16 16">
      <title>arrow-down</title>
      <path
        d="M0 8L1.5 6.5L7 12L7 0L9 0V12L14.5 6.5L16 8L8 16L0 8Z"
        fill="#001E64"
      />
    </symbol>
    <symbol id="icon-info" viewBox="0 0 16 16">
      <title>info</title>
      <circle id="bg" cx="8" cy="8" r="8" fill="#001E64" />
      <path
        id="i"
        d="M7.63484 13.196C7.49484 13.196 7.39684 13.1773 7.34084 13.14C7.28484 13.1027 7.25684 13.028 7.25684 12.916L8.05484 6.25201C8.08284 6.01867 8.26484 5.90201 8.60084 5.90201C8.93684 5.90201 9.10484 5.99534 9.10484 6.18201L8.29284 12.846C8.26484 13.0793 8.0455 13.196 7.63484 13.196ZM9.66484 3.31201C9.66484 3.89067 9.39884 4.18001 8.86684 4.18001C8.44684 4.18001 8.23684 4.00267 8.23684 3.64801C8.23684 3.07867 8.50284 2.79401 9.03484 2.79401C9.45484 2.79401 9.66484 2.96667 9.66484 3.31201Z"
        fill="white"
      />
    </symbol>
    <symbol id="icon-play" viewBox="0 0 48 48">
      <title>play</title>
      <path d="M0 0H48V48H0V0Z" fill="#0078D4" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19 18L31 24L19 30V18ZM17.7107 31.7747C17.9533 31.924 18.2267 32 18.5013 32C18.7293 32 18.96 31.948 19.1747 31.8413L32.168 25.3442C32.6813 25.0868 33 24.5735 33 24.0002C33 23.4269 32.6813 22.9135 32.168 22.6562L19.172 16.1577C18.7013 15.9244 18.156 15.9524 17.7107 16.2257C17.2653 16.5017 17 16.979 17 17.503V30.4974C17 31.0214 17.2653 31.4987 17.7107 31.7747Z"
        fill="white"
      />
    </symbol>
    <symbol id="icon-pause" viewBox="0 0 48 48">
      <title>pause</title>
      <path d="M0 0H48V48H0V0Z" fill="#0078D4" />
      <path d="M19 16H21V32H19V16Z" fill="white" />
      <path d="M28 16H30V32H28V16Z" fill="white" />
    </symbol>
    <symbol id="icon-excel-doc" viewBox="0 0 24 24">
      <title>excel-doc</title>
      <g id="Icon-24x24-XLS">
        <path
          id="xls"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5 0V24H24V4L20.1026 0H5ZM7 2V22H22V5.33333L18.9231 2H7Z"
          fill="currentColor"
        />
        <g id="Vector">
          <path d="M0 6.88867H23.6V19.9998H0V6.88867Z" fill="currentColor" />
          <path
            d="M15.385 14.9346L16.86 14.7912C16.9487 15.2863 17.128 15.6499 17.3977 15.8821C17.6709 16.1143 18.0379 16.2303 18.4989 16.2303C18.9871 16.2303 19.3542 16.1279 19.6 15.923C19.8492 15.7148 19.9739 15.4724 19.9739 15.1958C19.9739 15.0182 19.9209 14.868 19.8151 14.7451C19.7127 14.6188 19.5317 14.5095 19.2722 14.4173C19.0947 14.3559 18.6901 14.2466 18.0584 14.0895C17.2458 13.8881 16.6756 13.6406 16.3478 13.3469C15.8869 12.9338 15.6564 12.4302 15.6564 11.8361C15.6564 11.4537 15.764 11.0969 15.9791 10.7657C16.1976 10.4311 16.51 10.1767 16.9163 10.0026C17.326 9.82844 17.8194 9.74137 18.3964 9.74137C19.3388 9.74137 20.0473 9.94794 20.5219 10.3611C20.9999 10.7742 21.2508 11.3256 21.2747 12.0153L19.7588 12.0819C19.6939 11.6961 19.5539 11.4195 19.3388 11.2522C19.1271 11.0815 18.8079 10.9961 18.3811 10.9961C17.9406 10.9961 17.5958 11.0866 17.3465 11.2676C17.186 11.3837 17.1058 11.539 17.1058 11.7336C17.1058 11.9112 17.1809 12.0631 17.3312 12.1895C17.5224 12.3499 17.9867 12.5172 18.7242 12.6914C19.4617 12.8655 20.0063 13.0465 20.358 13.2343C20.7131 13.4186 20.9896 13.673 21.1877 13.9974C21.3891 14.3183 21.4898 14.7161 21.4898 15.1907C21.4898 15.6209 21.3703 16.0238 21.1313 16.3993C20.8923 16.7749 20.5543 17.0549 20.1173 17.2393C19.6802 17.4202 19.1356 17.5107 18.4835 17.5107C17.5343 17.5107 16.8053 17.2922 16.2966 16.8552C15.7879 16.4147 15.484 15.7745 15.385 14.9346Z"
            fill="white"
          />
          <path
            d="M9.39799 17.3776V9.93094H10.914V16.1126H14.6834V17.3776H9.39799Z"
            fill="white"
          />
          <path
            d="M1.59779 17.3777L4.16367 13.4598L1.8385 9.86957H3.61054L5.11627 12.2818L6.59127 9.86957H8.34795L6.01253 13.5161L8.57841 17.3777H6.75003L5.08554 14.7811L3.41593 17.3777H1.59779Z"
            fill="white"
          />
        </g>
      </g>
    </symbol>
    <symbol id="icon-pdf-doc" viewBox="0 0 24 24">
      <title>pdf-doc</title>
      <g id="Icon-24x24-PDF">
        <path
          id="pdf"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5 0V24H24V4L20.1026 0H5ZM7 2V22H22V5.33333L18.9231 2H7Z"
          fill="currentColor"
        />
        <g id="Vector">
          <path d="M0 6.66602H24V19.9993H0V6.66602Z" fill="currentColor" />
          <path
            d="M16.9377 17.3326V9.69718H22.172V10.9889H18.4793V12.7961H21.6668V14.0878H18.4793V17.3326H16.9377Z"
            fill="white"
          />
          <path
            d="M9.2137 9.69718H12.0314C12.6668 9.69718 13.1512 9.7458 13.4845 9.84302C13.9325 9.97496 14.3161 10.2093 14.6356 10.5461C14.955 10.8829 15.1981 11.2961 15.3647 11.7857C15.5314 12.2718 15.6147 12.8725 15.6147 13.5878C15.6147 14.2163 15.5366 14.7579 15.3804 15.2128C15.1894 15.7684 14.9168 16.218 14.5627 16.5618C14.2953 16.8222 13.9342 17.0253 13.4793 17.1711C13.1391 17.2788 12.6842 17.3326 12.1147 17.3326H9.2137V9.69718ZM10.7554 10.9889V16.0461H11.9064C12.337 16.0461 12.6477 16.0218 12.8387 15.9732C13.0887 15.9107 13.2953 15.8048 13.4585 15.6555C13.6252 15.5062 13.7606 15.2614 13.8647 14.9211C13.9689 14.5774 14.021 14.1104 14.021 13.5201C14.021 12.9298 13.9689 12.4767 13.8647 12.1607C13.7606 11.8448 13.6147 11.5982 13.4272 11.4211C13.2397 11.2441 13.0019 11.1243 12.7137 11.0618C12.4984 11.0132 12.0766 10.9889 11.4481 10.9889H10.7554Z"
            fill="white"
          />
          <path
            d="M2.10417 17.3327V9.69727H4.57812C5.51562 9.69727 6.12674 9.73546 6.41146 9.81185C6.84896 9.92643 7.21528 10.1764 7.51042 10.5618C7.80556 10.9438 7.95313 11.4386 7.95313 12.0462C7.95313 12.515 7.86806 12.9091 7.69792 13.2285C7.52778 13.548 7.31076 13.7997 7.04688 13.9837C6.78646 14.1643 6.52083 14.2841 6.25 14.3431C5.88194 14.416 5.34896 14.4525 4.65104 14.4525H3.64583V17.3327H2.10417ZM3.64583 10.9889V13.1556H4.48958C5.09722 13.1556 5.50347 13.1157 5.70833 13.0358C5.91319 12.9559 6.07292 12.8309 6.1875 12.6608C6.30556 12.4907 6.36458 12.2928 6.36458 12.0671C6.36458 11.7893 6.28299 11.5601 6.11979 11.3796C5.9566 11.199 5.75 11.0862 5.5 11.041C5.31597 11.0063 4.94618 10.9889 4.39062 10.9889H3.64583Z"
            fill="white"
          />
        </g>
      </g>
    </symbol>
    <symbol id="icon-caret-thin-up" viewBox="0 0 12 8">
      <title>caret-thin-up</title>
      <path
        d="M6,4.6L10.6,0L12,1.4l-6,6l-6-6L1.4,0L6,4.6z"
        fill="currentColor"
      />
    </symbol>
    <symbol id="icon-caret-thin-down" viewBox="0 0 909.1 560.6">
      <title>caret-thin-down</title>
      <g transform="matrix(75.7576 0 0 -75.7576 500.0001 500.0001)">
        <path
          vectorEffect="non-scaling-stroke"
          d="M-0.6,3.8L4-0.8l1.4,1.4l-6,6l-6-6l1.4-1.4L-0.6,3.8z"
          fill="currentColor"
        />
      </g>
    </symbol>
  </svg>
);

document.addEventListener('DOMContentLoaded', () => {
  const div = document.createElement('div');
  const body = document.body;

  div.id = 'sprite-wrapper';
  div.style.display = 'none';

  body.appendChild(div);

  const root = createRoot(div);
  root.render(<Icons />);
});
